
/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";
// reactstrap components
import {
  Button,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  UncontrolledTooltip
} from "reactstrap";
import black_logo from "assets/img/brand/black-logo.png"

class SimpleFooter extends React.Component {
  render() {
    return (
      <>
        <footer className=" footer mt-5">
            <Row className=" row-grid align-items-center m-0">
              <Col lg="12" className="d-flex align-items-center justify-content-center">
                <img width="100px" className="mr-2" src={black_logo}/>
                <h6 className=" mb-0 font-weight-light text-center ml-3 mr-3" style={{fontSize:12}}>
                  Big Branding-Wholesale Workwear & Uniform Shop | Unit 1/10 Klauer St Seaford Vic 3198 | <a href="tel:(03) 9786 5005"><strong style={{fontSize:17}}>(03) 9786 5005</strong></a> | team@bigbranding.com.au | www.bigbranding.com.au
                  
                </h6>
                <a target="_blank" href="https://www.facebook.com/BIGbranding.com.au" className="mr-2">
                  <span className="social-icon">
                    <i className="fa fa-facebook"
                            style={{cursor:'pointer'}}
                    ></i>   
                  </span>
                </a>
                <a target="_blank" href="https://www.instagram.com/bigbranding_com_au/">
                  <span className="social-icon">
                    <i className="fa fa-instagram"
                            style={{cursor:'pointer'}}
                    ></i>  
                  </span>
                </a>         
              </Col>
            </Row>
        </footer>
      </>
    );
  }
}

export default SimpleFooter;
